import axios from "axios";

export const state = {
    expensecategories: [],
};

export const getters = {
    expensecategories: state => state.expensecategories,
};

export const mutations = {
    setExpensecategories(state, newValue) {
        state.expensecategories = newValue
    },
};

export const actions = {
    fetchExpensecategories({ commit }) {
        axios.get('/expensecat').then(res => {
            commit('setExpensecategories', res.data.categories)
        })
    },
};